module.exports = __webpack_public_path__ + "Roboto-Regular.99b14f0da0591e0d7167.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Regular.ttf
// module chunks = styles